export default __webpack_public_path__ + "static/media/percent.941f6b80.svg";